
import { Vue, Options } from "vue-class-component";
import Settings from "@/components/Settings.vue";

@Options({
  components: {
    Settings,
  },
})
export default class App extends Vue {
  loaded = false;

  mounted() {
    const computed = window.getComputedStyle(this.$refs.app as Element);
    this.$store.commit("setDimensions", {
      width: parseInt(computed.getPropertyValue("--meme-width")),
      height: parseInt(computed.getPropertyValue("--meme-height")),
    });
    this.loaded = true;
  }
}
